var React = require('react');

function PosLine (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.49876 235.684L507.68 1.78634L508.453 187.584L1.49876 421.479V235.684Z","stroke":"#FFCC00","strokeWidth":"1.80611"}));
}

PosLine.defaultProps = {"width":"339","height":"393","viewBox":"0 0 339 393","fill":"none"};

module.exports = PosLine;

PosLine.default = PosLine;
